import React from 'react'

export default function HeroSection() {
    return (
        <div className='hero-section d-flex align-items-center justify-content-start'>
            <h1 className='hero-title'>A Plywood<br /> for everyone</h1>
        </div>
    )
}